const MAX_HEADER_OFFSET = 120;

export const BANNER_HEADER_OFFSET_CHANGE_EVENT = 'banner-header-offset-change';

const bannerHeightsByContainer = new Map<string, number>();
const desiredOffsetsByContainer = new Map<string, number>();

function applyGlobalOffset(): void {
  const maxOffset =
    desiredOffsetsByContainer.size === 0
      ? 0
      : Math.max(0, ...desiredOffsetsByContainer.values());
  document.documentElement.style.setProperty(
    '--banner-header-offset',
    `${maxOffset}px`
  );
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BANNER_HEADER_OFFSET_CHANGE_EVENT));
  }
}

export function getVisibleBannerHeight(
  containerId: string,
  container: HTMLElement,
  maxOffset: number
): number {
  const bannerHeight = bannerHeightsByContainer.get(containerId) ?? 0;
  if (!bannerHeight) return 0;

  const rect = container.getBoundingClientRect();
  const visibleHeight = Math.min(bannerHeight, Math.max(rect.bottom, 0));
  return Math.min(visibleHeight, maxOffset);
}

export function applyHeaderOffset(containerId: string, offset: number): void {
  desiredOffsetsByContainer.set(containerId, offset);
  applyGlobalOffset();
}

export function setBannerHeight(containerId: string, height: number): void {
  bannerHeightsByContainer.set(containerId, height);
}

export function resetBannerHeight(containerId: string): void {
  bannerHeightsByContainer.delete(containerId);
  desiredOffsetsByContainer.delete(containerId);
  applyGlobalOffset();
}

export function getMaxHeaderOffset(): number {
  return MAX_HEADER_OFFSET;
}

export function getBannerOffset(): number {
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    '--banner-header-offset'
  );
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}
